import iconDone from "../../../Icons/icons-charcoal-dark/done.png";
import iconCamara from "../../../Icons/icons-white/camara.png";

import iconBack from "../../../Icons/NV/yellow/back.png";
import iconListed from "../../../Icons/icons-white/listed.png";
import iconWhiteAhead from "../../../Icons/icons-white/go.png";
import iconAccount from "../../../Icons/icons-charcoal-dark/account.png";
// import iconBusiness from "../../../Icons/nav-icons/active/business.png";

import iconBlackMap from "../../../Icons/icons-black/map.png";
import iconWhiteMap from "../../../Icons/icons-white/map.png";
import iconBluePinPoint from "../../../Icons/NV/blue/pin point.png";

import iconBlackCamara from "../../../Icons/icons-black/camera.png";
import iconBlueUploadImage from "../../../Icons/icons-blue/upload-image.png";
import iconBlackVideo from "../../../Icons/icons-black/video.png";

import iconWhiteDone from "../../../Icons/NV/white/done.png";
import iconWhiteLink from "../../../Icons/NV/white/link.png";
import iconYellowLocation from "../../../Icons/NV/yellow/location-outline.png";
import GENRALHELPERS from "../GENRAL-HELPERS";
{
  /* <div class="CreateListingOptionsInputCon1">
        <div class="CreateListingOptionsInputCon2">
          <div class="NVCreateListingText2">Número para llamadas</div>
          <div class="CreateListingImportantMessage">
            El número debe ser del país de México, ya que ocupamos '+52' en todos los
            números.
          </div>
          <div class="CreateListingOptionsInputCon3">
            <input class="CreateListingOptionsInputInput" type="text" name=""
            placeholder="1234567890" id="CreateListingCallNumber" inputmode="numeric"
            maxlength="10"
            value="${callNumber}" ${edit ? "" : "readonly"} />
          </div>
        </div>
        <div id="CreateListingErrorMessageCallingNumber" class="CreateListingErrorMessage"></div>
      </div>
      <div class="CreateListingOptionsInputCon1">
        <div class="CreateListingOptionsInputCon2">
          <div class="NVCreateListingText2">Número para WhatsApp</div>
          <div class="CreateListingImportantMessage">
            El número debe ser del país de México, ya que ocupamos '+52' en todos los
            números.
          </div>
          <div class="CreateListingOptionsInputCon3">
            <input class="CreateListingOptionsInputInput" type="text" name=""
            placeholder="1234567890" id="CreateListingWhatsNumber" inputmode="numeric"
            maxlength="10"
            value="${whatsNumber}" ${edit ? "" : "readonly"} />
          </div>
        </div>
        <div id="CreateListingErrorMessageWhatsAppNumber" class="CreateListingErrorMessage"></div>
      </div> */
}

class GenerateHTML {
  _display(data) {
    let edit = true;
    console.log(data);

    let locationName = 'Ubicación no seleccionado'

    if (data?.place?.lat) {
      locationName = GENRALHELPERS._getDisplayLocationName(data.place)

    }

    //   <div class="CreateListingNameUlrText">
    //   https://mqmexico.com/listings/john-deere-9600-2018
    // </div>


    // <div class="LogInCon6">
    //   <div data-helpwith="createListing" class="WalletCon8 openHelp">
    //     <div class="WalletText4">¿Como puedo crear un listado?</div>
    //   </div>
    // </div>


    // <div class="CreateListingImagesCon5">
    //   <img class="CreateListingImageUploadIcon" src="${iconBlackCamara}" alt="" height="24px" />
    //   <div class="CreateListingImagesCon5C">
    //     <div class="CreateListingImagesAddImagesText1">Fotos</div>
    //   </div>
    // </div>

    return `
<div id="SearchStartUpComponentAllCon" class="CreateListingCon1">
  <div class="CreateListingCon2A">


    <div class="CreateListingImagesCon1">
      <div id="CreateListingImagesCon2" class="CreateListingImagesCon2" style="display: none">
        <div class="CreateListingImagesCon2A">
          <div class="CreateListingImagesCon3" id="uploaded-images-container">
            <!-- Images will be dynamically added here -->
          </div>
        </div>
        <div class="CreateListingImagesCon4">
          <div id="CreateListingImageOrganizeMessage" class="CreateListingImagesOrganizeText CreateListingImagesAddImagesTextHidden">
            Arrastra las imágenes para cambiar su orden. La primera imagen aparecerá como portada en las búsquedas.
          </div>
        </div>
      </div>

      <div class="createListingImageUploadCon1">
        <div class="createListingImageUploadCon2">
          <div id="createListingImageUploadText1" class="createListingImageUploadText1">¡Tu listado merece excelentes imágenes!</div>
          <div class="createListingImageUploadCon3">
            <img id="upload-trigger" src="${iconBlueUploadImage}" alt="" height="90px" />
          </div>
        </div>
      </div>
  

      <div class="CreateListingImagesCon5A">
        <div class="CreateListingImagesCon5BAA">
          <div class="CreateListingImagesCon5Text">Agrega también (opcional)</div>
        </div>
        <div class="CreateListingImagesCon5BA">
          <div class="CreateListingImagesCon5B">

            <div class="CreateListingImagesCon5" id="upload-trigger-video">
              <img class="CreateListingImageUploadIcon" src="${iconBlackVideo}" alt="" height="24px" />
              <div class="CreateListingImagesCon5C">
                <div class="CreateListingImagesAddImagesText1">Video</div>
              </div>
              <div id="CreateListingImagesCon5C1" class="CreateListingImagesCon5C1" style="display: none">
                <img class="CreateListingImageUploadIconB" src="${iconWhiteDone}" alt="" />
              </div>
            </div>

            
            <div class="CreateListingImagesCon5" id="upload-trigger-location" style="display: none">
                <img class="CreateListingImageUploadIcon" src="${iconYellowLocation}" alt="" height="24px" />
              <div class="CreateListingImagesCon5C">
                <div class="CreateListingImagesAddImagesText1">Ubicación</div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <input type="file" id="image-upload-input" multiple accept="image/*" style="display: none" />
      <div class="NVCreateListingCon1">
        <div id="CreateListingErrorMessageImages" class="CreateListingErrorMessage"></div>
      </div>
    </div>

    <div class="CreateListingCon1B">


      <div id="CreateListingCon2InputForVidUrl" class="CreateListingCon2 CreateListingCon2Hidden">
        <div class="CreateListingNameCon1">
          <div id="nvV1CreateListignPreviewVidCon1" class="nvV1CreateListignPreviewVidCon1"></div>

          <div class="NVCreateListingText2">Enlace del video (solo YouTube)</div>
            <div class="CreateListingNameCon1B">
              <input class="CreateListingNameInput" type="text" placeholder="URL de un video" id="CreateListingVideoURL" />
              <div id="CreateListingVideoURLPasteFromClipBoardButton" class="CreateListingNameCon1B2">
                <img class="" src="${iconWhiteLink}" alt="" height="7px" />
                Pegar
              </div>
            </div>
          <div class="CreateListingNameCon2">Primero sube tu video a YouTube, luego copia el enlace y pégalo aqui. Asegúrate que sea un enlace válido, y que no hay restricciónes en el video.</div>


            <div class="CreateListingNameCon1C">
              <div class="CreateListingNameCon2B">Después que se genera la vista previa del video  puedes cerrar esta ventana con seguridad; esto no impedirá que el video se agregue a tu listado.</div>
              <div class="CreateListingNameCon1CA">
                <div id="CreateListingVideoURLPreviewVideoButton" class="CreateListingNameCon1C2">Generar vista previa</div>
                <div id="CreateListingVideoURLCloseVideoButton" class="CreateListingNameCon1C2A">Cerrar</div>
              </div>
            </div>


          <div id="CreateListingErrorMessageVideoURL" class="CreateListingErrorMessage"></div>
        </div>
      </div>



      <div class="CreateListingCon2 CreateListingCon2TopBorderRadius">
        <div class="CreateListingNameCon1">
          <div class="NVCreateListingText2">Titulo de tu listados</div>
          <textarea
            id="CreateListingName"
            class="CreateListingNameInputB"
            rows="1"
            placeholder="¿Que es lo que vendes?"
          ></textarea>
          <div class="NVCreateListingCon1">
            <div class="NVCreateListingText3">Dale a tu listado un titulo corto y descriptivo; esto ayuda a que nuestro
              buscador lo encuentre más fácilmente.</div>
          </div>
          <div id="CreateListingErrorMessageName" class="CreateListingErrorMessage"></div>
        </div>
      </div>


      <div class="CreateListingCon2">
        <div class="CreateListingOptionsInputCon1B">
          <div class="CreateListingOptionsInputCon1C">
            <div class="CreateListingOptionsInputCon2">
              <div class="NVCreateListingText2">Precio</div>
              <div class="CreateListingOptionsInputCon3">
                <input class="CreateListingOptionsInputInput" type="text" placeholder="$0" id="CreateListingPrice" inputmode="numeric" />
              </div>
              <div id="CreateListingErrorMessagePrice" class="CreateListingErrorMessage"></div>
            </div>

            <!-- Currency -->
            <div id="CreateListingCoin" class="CreateListingOptionsPicCon1">
              <div class="NVCreateListingText4">Moneda</div>
              <div data-coin="none" id="CreateListingCoinPic" class="CreateListingOptionsPicCon2">
                <div data-picked="MXN" class="CreateListingOptionsPicCon3">MXN</div>
                <div data-picked="USD" class="CreateListingOptionsPicCon3">USD</div>
              </div>
              <div id="CreateListingErrorMessageCoin" class="CreateListingErrorMessage"></div>
            </div>
          </div>


          <!-- Mark Price As -->
          <div id="CreateListingOptionsPicPriceMArkedAs" class="CreateListingOptionsPicCon1" style="display: none">
            <div class="NVCreateListingText2">Marcar precio como</div>
            <div data-pricemarked="none" id="CreateListingPicMarkPrice" class="CreateListingOptionsPicCon2">
              <div data-picked="negociable" class="CreateListingOptionsPicCon3">Negociable</div>
              <div data-picked="preguntar" class="CreateListingOptionsPicCon3">Preguntar por precio</div>
            </div>
          </div>

        </div> <!-- END CreateListingOptionsInputCon1B -->



        <div id="CreateListingPriceMoreOptionsCon" class="CreateListingPriceMoreOptionsCon1">
          <div id="CreateListingPriceMoreOptionsButton" class="CreateListingPriceMoreOptionsCon2">
            <div class="CreateListingPriceMoreOptionsText1">Mas opciones de precio</div>
          </div>
        </div>



        <!-- Discount -->
        <div id="CreateListingDiscount" class="CreateListingOptionsInputCon1B" style="display: none">
            <div class="NVCreateListingText2">Ajustar descuento</div>
            <div class="CreateInputAdjustDiscountOnPriceCon2">

              <div class="CreateListingOptionsPicCon1">
                <div class="NVCreateListingText4">porcentaje %</div>
                <input class="CreateListingOptionsInputInput CreateListingOptionsInputInputMini" type="text" placeholder="0%" id="CreateListingDiscountPercent" inputmode="numeric" />
              </div>

              <div class="CreateListingOptionsPicCon1">
                <div class="NVCreateListingText4">descuento $</div>
                <input class="CreateListingOptionsInputInput CreateListingOptionsInputInputMini" type="text" placeholder="$0" id="CreateListingDiscountAmount" inputmode="numeric" />
              </div>

              <div class="CreateListingOptionsPicCon1">
                <div class="NVCreateListingText4">precio ahora $</div>
                <input class="CreateListingOptionsInputInput CreateListingOptionsInputInputMini" type="text" placeholder="$0" id="CreateListingDiscountFinalPrice" inputmode="numeric" />
              </div>

            </div> <!-- END CreateInputAdjustDiscountOnPriceCon2 -->

        </div> <!-- END CreateListingOptionsInputCon1B -->
      </div>



      <div class="CreateListingCon2">
        <div class="CreateListingCon2B">
          <div class="NVCreateListingText2">Ubicación de tu listados</div>
          <div class="NVCreateListingText2B">¿Por qué agregar ubicación? <br> Permite que tu listado aparezca en “Cerca de mí” y llegue a más clientes cercanos.</div>
        </div>
        
        <div id="nvCreateNewListingButtonOpenLocationSelector" class="nvBusinessEditorIn4Con5B margin10px0">
          <div class="nvBusinessEditorIn4Con6A">
            <div class="nvBusinessEditorIn4Con6">
              <img height="20" src="${iconBlackMap}"/>
              <div class="nvBusinessEditorIn4Text3">Google Maps</div>
            </div>
            <div class="nvBusinessEditorIn4Con7">
              <div class="nvBusinessEditorIn4Text4">Ubicación</div>
              <div class="nvBusinessEditorIn4Text5">Toca aquí para abrir el mapa y poner la ubicación de tu negocio</div>
            </div>
          </div>
          <div class="nvBusinessEditorIn4Con7B">
            <img height="12px" src="${iconBluePinPoint}"/>
            <div id="nvCreateNewListingButtonOpenLocationSelectorLocationTag" class="nvBusinessEditorIn4Text4B">${locationName}</div>
          </div>
        </div>

        <div class="NVCreateListingCon1">
          <div id="CreateListingErrorMessageLocation" class="CreateListingErrorMessage"></div>
        </div>

        <div class="CreateListingPriceMoreOptionsCon1">
          <div id="CreateListingLocationUseMyLocationButton" class="CreateListingPriceMoreOptionsCon4">
            <div class="CreateListingPriceMoreOptionsText2">Usar mi ubicación</div>
            <img height="14" src="${iconWhiteMap}"/>
          </div>
        </div>

      </div>


      <div id="CreateListingOptionalCategorySection" class="CreateListingCon2" style="display: none">
        <div class="nvCreateNewListingCustomSelectCon1">
          <div class="nvCreateNewListingCustomSelectText1">Categoría</div>
          <div class="nvCreateNewListingCustomSelectCon2">
            <div id="CreateListingSelectCategory" class="custom-select"></div>
          </div>
          <div id="CreateListingErrorMessageSelectMachine" class="CreateListingErrorMessage"></div>
        </div>

        <div class="nvCreateNewListingCustomSelectCon1">
          <div class="nvCreateNewListingCustomSelectText1">Marca</div>
          <div class="nvCreateNewListingCustomSelectCon2">
            <div id="CreateListingSelectBrand" class="custom-select"></div>
          </div>
          <div id="CreateListingErrorMessageSelectBrand" class="CreateListingErrorMessage"></div>
        </div>

        <div class="nvCreateNewListingCustomSelectCon1">
          <div class="nvCreateNewListingCustomSelectText1">Modelo</div>
          <div class="nvCreateNewListingCustomSelectCon2">
            <div id="CreateListingSelectModel" class="custom-select"></div>
          </div>
          <div id="CreateListingErrorMessageSelectModel" class="CreateListingErrorMessage"></div>
        </div>


        <div class="nvCreateNewListingCustomSelectCon1">
          <div class="nvCreateNewListingCustomSelectText1">Año</div>
          <div class="nvCreateNewListingCustomSelectCon2">
            <div id="CreateListingSelectYear" class="custom-select"></div>
          </div>
          <div id="CreateListingErrorMessageSelectYear" class="CreateListingErrorMessage"></div>
        </div>

        <div class="nvCreateNewListingCustomSelectCon1">
          <div class="nvCreateNewListingCustomSelectText1">Condición</div>
          <div class="nvCreateNewListingCustomSelectCon2">
            <div id="CreateListingSelectCondition" class="custom-select"></div>
          </div>
          <div id="CreateListingErrorMessageSelectCondition" class="CreateListingErrorMessage"></div>
        </div>
      </div>


      <div id="CreateListingOptionalItemsAvailableSection" class="CreateListingCon2" style="display: none">
        <!-- Units Available -->
        <div class="CreateListingOptionsInputCon2">
          <div class="NVCreateListingText2">Unidades disponibles</div>
          <div class="CreateListingOptionsInputCon3">
            <input class="CreateListingOptionsInputInput" type="text" placeholder="no especificado" id="CreateListingItemsAvailable" inputmode="numeric" value="0" />
          </div>
          <div id="CreateListingErrorMessageItemsAvailable" class="CreateListingErrorMessage"></div>
        </div>
        <div class="CreateListingOptionsPicCon1">
          <div class="NVCreateListingText4">Marcar articulo como</div>
          <div
            data-itemmarked="none"
            id="CreateListingMarkItemAsCon"
            class="CreateListingOptionsPicCon2"
          >
            <div data-picked="sobre pedido" id="" class="CreateListingOptionsPicCon3">
              Sobre pedido
            </div>

            <div data-picked="disponible en stock" id="" class="CreateListingOptionsPicCon3">
              Disponible en stock
            </div>

            <div data-picked="agotado" id="" class="CreateListingOptionsPicCon3">
              Agotado
            </div>
          </div>
          </div>
      </div>


      <div id="CreateListingOptionalMoreDescriptionSection" class="CreateListingCon2" style="display: none">
        <div class="CreateListingDescriptionCon1">
          <div class="NVCreateListingText2">Descripción de tu listado</div>
          <textarea class="CreateListingDescriptionTextarea" name="" id="CreateListingDescription"
            placeholder="Escribe todo los demás detalles aquí..."></textarea>
          <div class="NVCreateListingCon1">
            <div class="NVCreateListingText3">Dale una buena descripción a tu listado.</div>
          </div>
          <div id="CreateListingErrorMessageDescription" class="CreateListingErrorMessage"></div>
        </div>

        <div class="CreateListingDescriptionCon1">
          <div class="NVCreateListingText2">Notas Admin</div>
          <textarea class="CreateListingDescriptionTextarea" name="" id="CreateListingAdminNotes"
            placeholder="Información interna"></textarea>
          <div class="NVCreateListingCon1">
            <div class="NVCreateListingText3">Esta nota no será mostrado al publico. Es visible a los admins, y sirve para información interno del negocio sobre este listado.</div>
          </div>
          <div id="CreateListingErrorMessageAdminNotes" class="CreateListingErrorMessage"></div>
        </div>
      </div>
      
      
      <div class="CreateListingPriceMoreOptionsCon1">
        <div id="CreateListingMoreOptionsButton" class="CreateListingPriceMoreOptionsCon3">
          <div class="CreateListingPriceMoreOptionsText1">Mostrar opciones avanzados</div>
        </div>
      </div>

    </div> <!-- END CreateListingCon1B -->
  </div> <!-- END CreateListingCon2A -->



  
  <div id="SelectPublishProfileCon1R" class="SelectPublishProfileCon1" style="display: none">
    <div class="SelectPublishProfileCon2">
      <div class="SelectPublishProfileCon3">
        <div class="SelectPublishProfileText1">Selecciona en donde quieres publicar este listado</div>
        <div class="SelectPublishProfileCon4">
          <div id="SelectPublishProfileCon1SelectAccount" data-select="profile" class="SelectPublishProfileSelectCon1">
            <div id="SelectPublishProfileCon2SelectAccount" class="SelectPublishProfileSelectCon2">
              <div id="SelectPublishProfileCon3SelectAccount" class="SelectPublishProfileSelectCon3">
                <img height="30px" src="${iconAccount}"/>
              </div>
              <div id="SelectPublishProfileCon1SelectAccountName" class="SelectPublishProfileText3"></div>
            </div>
            <div class="SelectPublishProfileText4">Seleccionar perfil de vendedor</div>
          </div>
          <div id="SelectPublishProfileCon1SelectBusiness" data-select="page" class="SelectPublishProfileSelectCon1">
            <div id="SelectPublishProfileCon2SelectBusiness" class="SelectPublishProfileSelectCon2">
              <div id="SelectPublishProfileCon3SelectBusiness" class="SelectPublishProfileSelectCon3">
                <img height="30px" src="${iconAccount}"/>
              </div>
              <div id="SelectPublishProfileCon1SelectBusinessName" class="SelectPublishProfileText3"></div>
            </div>
            <div class="SelectPublishProfileText4">Seleccionar página de negocio</div>
          </div>
        </div>
      </div>
      <div class="SelectPublishProfileCon5">
        <div class="SelectPublishProfileCon6B">
          <div id="SelectPublishProfileCon1ButtonBack" class="SelectPublishProfileCon6">
            <div class="SelectPublishProfileText2">Regresar</div>
          </div>
        </div>
        <div class="SelectPublishProfileCon6B">
          <div id="SelectPublishProfileCon1ButtonPublish" class="SelectPublishProfileCon7">
            <div class="SelectPublishProfileText2">Publicar</div>
          </div>
        </div>
      </div>
    </div>
  </div>



  <div id="SelectPublishProfileCon1" class="nvSelectPublishProfileCon1" style="display: none">
    <div class="nvSelectPublishProfileCon2">
      <div class="nvSelectPublishProfileCon3">
        <div class="nvSelectPublishProfileText1">Selecciona un perfil para publicar este listado</div>
      </div>
      <div class="nvSelectPublishProfileCon4">
        <div class="nvSelectPublishProfileCon5">
          <div class="nvSelectPublishProfileCon6">
            <div class="nvSelectPublishProfileText2">Tu perfil de vendedor</div>
          </div>
          <div id="SelectPublishProfileConProfile" class="nvSelectPublishProfileCon6B">
          </div>
          <div class="nvSelectPublishProfileCon6">
            <div class="selectpublishprofiletext4">Tus negocios</div>
          </div>
          <div id="SelectPublishProfileConBusinesses" class="nvSelectPublishProfileCon6B">
          </div>
        </div>
      </div>
    </div>
    <div class="CreateListingCon5B CreateListingCon5B2">
      <div id="CreateListingBtnBack" class="CreateListingCon5ButtonCancel topRightExitButtonOnFullScreenWindow">
        Regresar
      </div> 
      <div id="CreateListingBtnPublishNow" class="CreateListingCon5ButtonCreateListing">
        <p>Publicar Gratis</p>
        <img height="18px" src="${iconListed}" />
      </div>
    </div>
  </div>
  





  <div class="CreateListingCon5B">
    <div id="CreateListingBtnCancel" class="CreateListingCon5ButtonCancel topRightExitButtonOnFullScreenWindow">
      Cancelar
    </div> 
    <div id="CreateListingBtnPublish" class="CreateListingCon5ButtonCreateListing">
      <p>Siguiente</p>
      <img height="18px" src="${iconWhiteAhead}" />
    </div>
  </div>



</div> <!-- END CreateListingCon1 -->

      `;
  }
  _returProfileHTML(data, account) {
    let actClass = "";

    if (data.act) {
      actClass = "nvSelectPublishProfileProfileCon1Act";
    }

    let imgClass = "nvSelectPublishProfileProfileCon4";
    if (data.type === "profile") {
      imgClass = "nvSelectPublishProfileProfileCon4Profile";
    }
    return `
      <div data-businessid="${data?.businessId || ''}" data-sellerid="${data?.userId || account.userId || ''}" data-type="${data.type}" class="nvSelectPublishProfileProfileCon1 ${actClass}">
        <div class="nvSelectPublishProfileProfileCon3">
          <img class="${imgClass}" src="${data.photoURL}" alt=""/>
          <div class="nvSelectPublishProfileProfileCon5">
            <div class="nvSelectPublishProfileProfileText2">${data.name}</div>
            <div class="nvSelectPublishProfileProfileText3">${data.description}</div>
          </div>
          <div class="nvSelectPublishProfileProfileCon2">
            <div class="nvSelectPublishProfileProfileText1">${data.role}</div>
          </div>
        </div>
      </div>
    `;
  }
  _returNoProfileHTML() {
    return `
      <div class="nvSelectPublishProfileProfileCon6">
        <div class="nvSelectPublishProfileProfileCon7">
          <div class="nvSelectPublishProfileProfileText4">No tienes empresas creados aún.</div>
          <div class="nvSelectPublishProfileProfileText5">Crea una empresa primero luego podrás publicar tus listado bajo esta empresa</div>
        </div>
        <div id="CreateListingBtnCreateBusiness" class="nvSelectPublishProfileProfileCon8">
          Crear una empresa
        </div>
      </div>
    `;
  }

  _returnVideoPreviewHTML(url) {

    if (!url) return "";

    function isYouTubeUrl(url) {
      return /^(https?:\/\/)?(www\.)?(youtube\.com\/|youtu\.be\/|youtube\.com\/shorts\/)/.test(url);
    }

    function extractYouTubeId(url) {
      let match;

      if (/youtube\.com\/shorts\/(.+)$/.test(url)) {
        match = url.match(/youtube\.com\/shorts\/([^?&]+)/);
      } else {
        const ytRegex = /(?:youtube\.com\/.*v=|youtu\.be\/)([^&?#]+)/;
        match = url.match(ytRegex);
      }

      return match ? match[1] : null;
    }

    let videoElement = "";

    if (isYouTubeUrl(url)) {
      const videoId = extractYouTubeId(url);

      if (!videoId) return "";

      videoElement = `
      <iframe
        class="nvV1CreateListignPreviewVidCon4"
        src="https://www.youtube.com/embed/${videoId}"
        frameborder="0"
        allowfullscreen>
      </iframe>
    `;

    } else {

      videoElement = `
      <video class="nvV1CreateListignPreviewVidCon4" controls preload="metadata">
        <source src="${url}" type="video/mp4">
      </video>
    `;

    }

    return `

    <div class="nvV1CreateListignPreviewVidCon2">
      <div class="nvV1CreateListignPreviewVidCon3">
        
        ${videoElement}

        <div class="nvV1CreateListignPreviewVidCon5">
          <div class="nvV1CreateListignPreviewVidText1">Enlace: ${url}</div>
          <div class="nvV1CreateListignPreviewVidCon6">
            <div class="nvV1CreateListignPreviewVidCon7">
              <div id="CreateListingVideoURLDeleteVideoButton" class="nvV1CreateListignPreviewVidText2">Eliminar</div>
            </div>
          </div>
        </div>

      </div>
    </div>

  `;
  }

  _returnVideoPreviewHTMLV2(url) {

    if (!url) return "";

    function isYouTubeUrl(url) {
      return /^(https?:\/\/)?(www\.)?(youtube\.com\/|youtu\.be\/|youtube\.com\/shorts\/)/.test(url);
    }

    function extractYouTubeId(url) {
      let match;

      if (/youtube\.com\/shorts\/(.+)$/.test(url)) {
        match = url.match(/youtube\.com\/shorts\/([^?&]+)/);
      } else {
        const ytRegex = /(?:youtube\.com\/.*v=|youtu\.be\/)([^&?#]+)/;
        match = url.match(ytRegex);
      }

      return match ? match[1] : null;
    }

    let videoElement = "";

    if (isYouTubeUrl(url)) {

      const videoId = extractYouTubeId(url);
      if (!videoId) {
        this._setVideoStatus(false);
        return "";
      }

      videoElement = `
      <iframe
        class="nvV1CreateListignPreviewVidCon4"
        src="https://www.youtube.com/embed/${videoId}"
        frameborder="0"
        allowfullscreen
        onload="window._videoPreviewLoaded && window._videoPreviewLoaded(true)">
      </iframe>
    `;

    } else {

      videoElement = `
      <video
        class="nvV1CreateListignPreviewVidCon4"
        controls
        preload="metadata"
        onloadeddata="window._videoPreviewLoaded && window._videoPreviewLoaded(true)"
        onerror="window._videoPreviewLoaded && window._videoPreviewLoaded(false)">
        <source src="${url}" type="video/mp4">
      </video>
    `;

    }

    return `
    <div class="nvV1CreateListignPreviewVidCon2">
      <div class="nvV1CreateListignPreviewVidCon3">

        ${videoElement}

        <div class="nvV1CreateListignPreviewVidCon5">
          <div class="nvV1CreateListignPreviewVidText1">Enlace: ${url}</div>
          <div class="nvV1CreateListignPreviewVidCon6">
            <div class="nvV1CreateListignPreviewVidCon7">
              <div id="CreateListingVideoURLDeleteVideoButton" class="nvV1CreateListignPreviewVidText2">Eliminar</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  `;
  }
}
export default new GenerateHTML();
